<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	
	<div class="d-flex align-items-center">

		<div>
			<el-form inline ref="form" :model="searchform">

				<el-form-item class="mb-0 mr-0">
						 <el-select v-model="searchform.value2" :placeholder="$t('searchText.상태선택')" size="mini" style="width:100px">
						   <el-option
								      v-for="item in searchform.searchOptions2"
								      :key="item.value"
								      :label="item.label"
								      :value="item.value">
								    </el-option>
						  </el-select>
					</el-form-item>

					<el-form-item class="mb-0 mr-0">
						 <el-select v-model="searchform.value" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:120px">
						   <el-option
								      v-for="item in searchform.searchOptions"
								      :key="item.value"
								      :label="item.label"
								      :value="item.value">
								    </el-option>
						  </el-select>
					</el-form-item>


					<el-form-item class="mb-0 mr-0">
						 <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px" ></el-input>
					</el-form-item>

           <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value4" multiple :placeholder="$t('msg.레벨선택')" size="mini">
               <el-option
                      v-for="item in searchform.searchOptions4"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>

					<el-form-item  class="mb-0 mr-0">
						 <el-date-picker
						      v-model="searchform.time"
						      type="daterange"
						      range-separator="~"
						      :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px">
						    </el-date-picker>
					</el-form-item>
					<el-form-item class="mb-0 mr-0">
						<el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>	
              <el-button type="success" size="mini" icon="el-icon-document-delete" @click="exportExcel" :disabled = "disabled">{{$t('searchText.엑셀다운')}}</el-button> 
					</el-form-item>
			</el-form>
       
		 
		
			
    		
		</div>
	
	</div>
  <div class="text-muted mt-2">
    <span class="text-info ml-2 mr-2">{{$t('searchText.출금계')}}:{{formatMoney(total_emoney)}}</span>
    <span class="text-info ml-2 mr-2">{{$t('searchText.출금계')}}:{{formatMoney(utotal_emoney)}}</span>
  </div>

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
         :row-class-name="tableRowClassName"
       border class="mt-2"
 :highlight-current-row="true"
        :empty-text="$t('tableText.데이타가없습니다')">
    
    <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{total-(currentPage-1)*30-scope.$index}}</template>
        </el-table-column>

          <el-table-column
        
        :label="$t('searchText.구분')" prop="money_type" v-if="this.sitetype=='4'" align="center" width="100">
         <template slot-scope="scope">
              <span :class="'text-primary'">{{iotypeObj[scope.row.money_type]}}</span>
             
          </template>
      </el-table-column>

      <el-table-column
        
         :label="$t('nav.아이디')" prop="io_id" align="center" width="100">
         <template slot-scope="scope">
            <div :style="{ backgroundColor: (userid === 'soft16' || userid === 'soft23') ? (String(scope.row.memState) === '1' ? '#d1fae5' : String(scope.row.memState) === '4' ? '#dbeafe' : scope.row.RaceYN) : scope.row.RaceYN }">
             <span @click="openModel(scope.row.io_id)" class="text-primary" style="cursor:pointer;">{{scope.row.io_id}}</span>
           </div>
          </template>
      </el-table-column>
      
         <el-table-column
        :label="$t('tableText.이름')" prop="io_in_name" align="center">
          <template slot-scope="scope">
            
             <span @click="bonOpen(1,scope.row.io_id)"  style="cursor:pointer" class="text-primary">{{scope.row.io_in_name}}({{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}})</span>
          </template>
      </el-table-column> 

       <template v-if="this.sitetype==='1' || this.sitetype==='3'">
      <el-table-column
         :label="$t('tableText.부본사총판추천인')"
       prop="b_code" align="center">
        <template slot-scope="scope">
          {{scope.row.b_code}}-{{scope.row.a_code}}-{{scope.row.m_cp}}
        </template>
      </el-table-column>
    </template>
    <template v-if=" this.sitetype==='4'">

      <el-table-column
          :label="$t('tableText.부본사총판매장')"
         prop="b_code" align="center">
        <template slot-scope="scope">
          {{scope.row.b_code}}-{{scope.row.a_code}}-{{scope.row.c_code}}
        </template>
      </el-table-column>
    </template>


       

      <el-table-column
         :label="$t('msg.출금금액')"
        prop="io_out_money" align="center">
        <template slot-scope="scope"><span class="text-danger">{{ formatMoney(scope.row.io_out_money)}}   </span>
     
     <template v-if="scope.row.io_out_money_usdt !=0  && userid=='diamond' ">
      <br>usdt: {{ scope.row.io_out_money_usdt }}
    </template>
      </template>

      </el-table-column>

      <el-table-column
        :label="$t('msg.롤링')"
        prop="" align="center" v-if="this.userid=='soft26'">
        <template slot-scope="scope"><span class="text-danger">{{scope.row.io_rolling}}%</span></template>

      </el-table-column>
     
      <el-table-column
        :label="$t('tableText.신청시잔액')"
        prop="io_jan" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.io_jan)}}</template>

      </el-table-column>

      <el-table-column
        :label="$t('tableText.현잔액')"
        prop="mem_cash" align="center">
          <template slot-scope="scope">{{ scope.row.mem_cash>0 ? formatMoney(scope.row.mem_cash):formatMoney(scope.row.api_money) }}</template>

      </el-table-column>

       <el-table-column
        :label="$t('tableText.계좌정보')"
         align="center">
        <template slot-scope="scope">
          {{scope.row.io_order!='' ? scope.row.mem_bankcode+' '+scope.row.mem_bankname+' '+scope.row.mem_banknum : scope.row.io_name}}
        </template>
      </el-table-column>

   
       
        <el-table-column
        
          :label="$t('tableText.아이피')" prop="sip" align="center">
      </el-table-column>
     

       <el-table-column
        :label="$t('tableText.신청시간')"
        prop="io_regdate" align="center">
      </el-table-column>
    
    

       <el-table-column
        :label="$t('tableText.완료시간')"
        prop="io_update" align="center">
      </el-table-column>

        <el-table-column
         
        :label="$t('tableText.상태')" prop="io_sangte" align="center">
      <template slot-scope="scope"> <span :class="iconObj[scope.row.io_sangte]">{{optionsObj[scope.row.io_sangte]}}</span>
 </template>
      </el-table-column>
       
      <el-table-column
           align="center"
          prop="io_sangte"
          width="200"
           >
          <template slot-scope="scope">
          <el-button v-if="scope.row.io_sangte=='1'" type="warning" size="mini" style="margin-left:0" @click="changeBtn(scope,'2')" :loading="btnLoad">{{$t('msg.처리중')}}</el-button>
           <el-button v-if="scope.row.io_sangte=='1' || scope.row.io_sangte=='2'" type="primary" size="mini" style="margin-left:0" @click="infoOpen(scope)" :loading="btnLoad">{{$t('msg.출금')}}</el-button>
            <el-button v-if="(scope.row.io_sangte=='1' || scope.row.io_sangte=='2') && sitetype=='4' " type="danger" size="mini" style="margin-left:0" @click="changeBtn(scope,'4')" :loading="btnLoad">{{$t('msg.취소')}}</el-button>
            <el-button v-if="(scope.row.io_sangte=='1' || scope.row.io_sangte=='2' || scope.row.io_sangte=='3') && sitetype!='4' " type="danger" size="mini" style="margin-left:0" @click="changeBtn(scope,'4')" :loading="btnLoad">{{$t('msg.취소')}}</el-button> 
      </template>
          </el-table-column>
    
		
		  
	
		 
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
       
                <el-dialog
  title=""
  :visible.sync="infoOpendialogVisible"
  width="800px"
  class="custom-dialog"
  >
  <div class="dialog-content">
   
  <el-table
    :data="infoData"
    border
 v-loading="infoloading"
    style="width: 100%;margin-top: 20px;">
    <el-table-column
      prop="io_id"
      label="아이디"  align="center">
    </el-table-column>
   
      
      <el-table-column prop="io_money"  label="입금액"  align="center">
           <template slot-scope="scope">{{ formatMoney(scope.row.io_money)}}</template>
      </el-table-column>
      <el-table-column prop="io_out_money"  label="출금액"  align="center">
            <template slot-scope="scope">{{ formatMoney(scope.row.io_out_money)}}</template>
      </el-table-column>
      <el-table-column prop="io_regdate"  label="신청시간"  align="center">
        
         <template slot-scope="scope">{{ scope.row.io_regdate }}</template>
      </el-table-column>
    
  
  </el-table>
  <div :style="{color:infoMsgColor}" class="text-center mt-3"><span style="font-size: 15px">{{infoMsg}}</span></div>
</div>
 

  <span slot="footer" class="dialog-footer">
    <el-button @click="infoOpendialogVisible = false">취소</el-button>
    <el-button type="primary" :loading="infobtnLoad" @click="okBtn('')">확인</el-button>
  </span>
</el-dialog>
				
</div>
 </template>

 <script>
 import layer from '../../components/common/layer.vue';
import layoutLayer from '../../components/common/layout-layer.vue';
import layerNew from '../../components/common/layer-new.vue';
 import * as XLSX from 'xlsx/xlsx.mjs';

    export default {
     components: {
      layer,layoutLayer,layerNew
    },
    	data(){
    		return{
           infoMsg:'',
          infoMsgColor:'',
          infoData:[],
            infobtnLoad:false,
          infoloading:false,
          infoOpendialogVisible:false,
          btnLoad:false,
          disabled:false,
            level_title:{
              '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")         
            },
          checked:'1',
          domain:window.sessionStorage.getItem('domain'),
           sitetype:window.sessionStorage.getItem('sitetype'),
           bg:window.sessionStorage.getItem('bg'),
           userid:window.sessionStorage.getItem('userid'),
           aid:window.sessionStorage.getItem('admin_id'),
          formLoading:false,
          idDialogVisible: false,
           iconObj:{
              '1':'text-primary',
              '2':'text-success',
              '3':'',
              '4':'text-cancel',
              '-4':'text-orange',
          
             
            },
             iotypeObj:{
              '1':this.$i18n.t("msg.파워볼"),
              '2':this.$i18n.t("searchText.카슬"),
               '3':this.$i18n.t("nav.알잔액"),
            },
             optionsObj:{
              '1':this.$i18n.t("msg.대기"),
              '2':this.$i18n.t("msg.처리중"),
              '3':this.$i18n.t("msg.완료"),
              '4':this.$i18n.t("msg.취소"),
              '5':this.$i18n.t("msg.삭제"),
              
            },
    			total_cash: '',
				total_ecash: '',
				total_emoney: '',
				total_money: '',

    		  options: [{
                label:this.$i18n.t("msg.대기") ,
                value: '1',
                disabled:false
               
              }, {
                label: this.$i18n.t("msg.처리중"),
                 value: '2',
                 disabled:false
                
              }, {
                label: this.$i18n.t("msg.완료"),
                 value: '3',
                 disabled:true
               
              }, {
                label: this.$i18n.t("msg.취소"),
                 value: '4',
                 //disabled:true
               
              }, {
                label: this.$i18n.t("msg.삭제"),
                 value: '5',
                 disabled:false
               
              }], 
              
    			searchform:{
    				keyword:'',
    				time:[],
    				searchOptions:[
                
    				{
              label:this.$i18n.t("msg.닉네임"),
              value:'io_in_name'
            },
            {
              label:this.$i18n.t("msg.입금인"),
              value:'io_name'
            },
            {
              label:this.$i18n.t("msg.예금주"),
              value:'mem_bankname'
            },
            {
              label:this.$i18n.t("msg.아이디"),
              value:'io_id'
            },
            {
              label:this.$i18n.t("msg.신청시ip"),
              value:'sip'
            },
		       

		        ],
		        searchOptions2:[
                
    			 {
              label:this.$i18n.t("msg.전체"),
              value:''
            },{
              label:this.$i18n.t("msg.대기"),
              value:'1'
            },
            
            {
              label:this.$i18n.t("msg.처리중"),
              value:'2'
            },
            {
              label:this.$i18n.t("msg.완료"),
              value:'3'
            },
            {
              label:this.$i18n.t("msg.취소"),
              value:'4'
            },
		        ],
             searchOptions4:[
               
           
            {
               label:this.$i18n.t("msg.기본"),
              value:'0'
            },
            {
              label:'V1',
              value:'1'
            },
            {
              label:'V2',
              value:'2'
            },
            {
              label:'V3',
              value:'3'
            },
            {
              label:'V4',
              value:'4'
            },
            {
              label:'V5',
              value:'5'
            },
            {
              label:'V6',
              value:'6'
            },
            {
              label:'V7',
              value:'7'
            },
            {
              label:'co',
              value:'8'
            }           
            ],
            value4:[],
		        value:'',
		        value2:'',


    			},
    			 pickerOptions: {
    			},
          shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
    
     
    			
		        
    		
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 editIndex:-1,
		    		 creatModel:false,
		    		 tableData: [],
			         currentPage:1,
			         multipleSelection:[],
			         superSearch:false,
                io_type:'',
            ioType: [
               {
                 label: this.$i18n.t("msg.충전"),
                 value: '1',
               
              }, {
                label: this.$i18n.t("msg.환전"),
                 value: '2',
               
              }],
          options1: [{
               
                label: this.$i18n.t("msg.게임머니"),
                 value: '1',
               
              }, {
                label: this.$i18n.t("msg.이벤트머니"),
                 value: '2',
               
              }],
            gubun:'',
           form:{
            mem_id:'',
            money:'',
            memo:'',
          },
           dWidth:'400px',
           dialogModel:false,
			         
			 
    			}
    			
    			
    		},
    		created() {
    			
                const timer4 = window.setInterval(()=>{
             this.getList()
            }, 60000)
            
            this.$once('hook:beforeDestroy', function () {
               window.clearInterval(timer4)
            })
    			this.getList();
    			
			
		},
    	
    	methods:{
         exportExcel() {
         let token=window.sessionStorage.getItem('user');
         this.disabled = true

         let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

          
           let urls=this.domain+'/admin/moneylist?level='+this.searchform.value4+'&excel=1&io_type=2&status='+this.searchform.value2+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;
          
          
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{

               if(response.data.code!=200)
               {
                 this.disabled = false
                   this.$message.error(response.data.msg);
                   return;
               }


               let data = response.data.data

                this.total = response.data.total


               let wopts = {
                  bookType: 'xlsx',
                  bookSST: true,
                  type: 'binary'
                };
                let workBook = {
                  SheetNames: ['Sheet1'],
                  Sheets: {},
                  Props: {}
                };

                let table =data
                this.disabled = false

      
 
      workBook.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(table);

      XLSX.utils.sheet_add_aoa(workBook.Sheets['Sheet1'], [["Created "+new Date().toISOString()]], {origin:-1});
      XLSX.writeFile(workBook, "moneyout.xlsb");

      this.$message.success(this.$i18n.t("msg.엑셀저장완료"))

                     
                     // this.tableData =data.data
                    
               
            }).catch((error) =>{

               this.disabled = false
              
               this.$message.error(error);
              this.loading = false
               
            })
      
     

 
  
    },
        bonOpen(e,id){
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layoutLayer,
                parent: this,
                data:{
                einfo:{e:e},
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['500px', '480px'],
        });
        
        },
          tableRowClassName({row, rowIndex}) {
     
       if (rowIndex%2 === 1) {
        return 'odd-row';
       }
       else{
         return 'edd-row';
       }
    },
        
         // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
         openModel(id){
           let pix=window.screen.width;
           
                let width='1080px';
                if(pix<1200)
                {
                  width='95%';
                }
          if(this.aid=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: id,
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                 area: [width+'', '700px'],
             
             });
              return;
           }
            let layerwidth='950px';
                if(pix<1200)
                {
                  layerwidth='95%';
                }
            this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: [layerwidth+'', '680px'],
         
        });
        },
    			 // 搜索事件
			searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                	 this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                	 return;
                }
                this.currentPage=1;

    			this.getList();

    		},
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			     
    		getList(){

    		  

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/moneylist?level='+this.searchform.value4+'&io_type=2&status='+this.searchform.value2+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                   
                     let data = response.data.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     this.total_cash = response.data.total_cash
                     this.total_ecash = response.data.total_ecash
                     this.total_emoney = response.data.total_emoney
                     this.total_money = response.data.total_money

                          this.utotal_emoney = response.data.utotal_emoney
                     this.utotal_money = response.data.utotal_money

                     this.loading =false
               
            }).catch((error) =>{
            	
               this.$message.error(error);
              this.loading = false
               
            })
    		},
        infoOpen(e){

         this.btnLoad = true
       
        let token=window.sessionStorage.getItem('user');
          this.$axios({
                      method:'post',
                       data:{
                        io_idx:e.row.io_idx,
                      
                     },
                      url:this.domain+'/admin/money_up_check',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                     
                    if(response.data.code==200){
                        
                        this.infoData = response.data.data
                         this.btnLoad = false;

                        if(this.infoData.length==0)
                        {
                           // this.infoloading = false;
                           // this.infoOpendialogVisible = false;
                             
                            this.changeBtn(e,'3');
                            return;
                        }

                         this.infoOpendialogVisible = true;
                        // this.infoloading = true

                        this.infoMsg = response.data.msg
                        this.infoMsgColor = response.data.color
                        this.io_idx = response.data.io_idx

                        
                    }else
                    {

                      this.infoloading = false
                       this.btnLoad = false;
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                  }).catch((error) =>{
                     this.infoloading = false
                      this.btnLoad = false;
                     this.infoOpendialogVisible = false;
                     this.changeBtn(e,'3');
                  })




      },
    		changeOptions(e){
               let token=window.sessionStorage.getItem('user');
               this.$axios({
                    method:'post',
                    url:this.domain+'/admin/money_up',
                    data:{
                       status:e.row.io_sangte,
                       id:e.row.io_idx
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
                }).then((response) =>{ 
                   console.log()
                   if(response.data.code==200)
                      {
                      	 this.$message({
		                      message:this.$i18n.t("msg.완료"),
		                      type: 'success'
		                    });

                           this.$router.replace('/refresh')
                         // this.getList();
                          
                      }else{
                       this.$message.error(response.data.msg)

                      }

                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
            },
        changeBtn(e,type){
          if(type=='4'){
               this.$prompt(this.$i18n.t("msg.취소하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.확인"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          inputPlaceholder: '쪽지로보낼시내용입력',
          type: 'warning'
        }).then((value) => {
          let token=window.sessionStorage.getItem('user');
          this.btnLoad = true
          this.$axios({
                      method:'post',
                      url:this.domain+'/admin/money_up',
                       data:{
                       io_money:e.row.io_money,
                       status:type,
                       id:e.row.io_idx,
                       msg:value.value
                    },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                    this.btnLoad = false
                    
                    if(response.data.code==200){
                      
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                       this.$router.replace('/refresh')
                    }else{
                      this.$message.error(response.data.msg)
                    }

                    
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })
            }
            else{
               let alt='';
          if(type=='2')
          {
             alt=this.$i18n.t("msg.처리중하시겠습니까");
          }else if(type=='3')
          {
             alt=this.$i18n.t("msg.확인하시겠습니까");
          }
          this.$confirm(alt, this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.확인"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');
          this.btnLoad = true
          this.$axios({
                      method:'post',
                      url:this.domain+'/admin/money_up',
                       data:{
                       status:type,
                       id:e.row.io_idx
                    },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                     this.btnLoad = false
                    
                    if(response.data.code==200){
                     
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                       this.$router.replace('/refresh')
                    }else{
                      this.$message.error(response.data.msg)
                    }

                    
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

            }
         
            },
             okBtn(e){

            let idx=  this.io_idx
            console.log(idx)
            //return;
            

   
       
          let token=window.sessionStorage.getItem('user');
          this.infobtnLoad = true
          this.$axios({
                      method:'post',
                      url:this.domain+'/admin/money_up',
                       data:{
                       
                       status:'3',
                       id:idx
                    },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                    this.infobtnLoad = false
                    
                    if(response.data.code==200){
                      
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                       this.$router.replace('/refresh')
                    }else{
                      this.$message.error(response.data.msg)
                    }

                    
    
                  }).catch((error) =>{
                      this.infobtnLoad = false
                      console.log(error)       //请求失败返回的数据
                  })
         
            },
    		
    		 getVal(e){

          if(this.form.money=='')
          {
this.form.money='0';
          }

          if(e=='0')
          {
            this.form.money='0';
          }

          this.form.money=parseInt(this.form.money)+parseInt(e)
          console.log(e)
        },
    	
    		
    	}
  }
</script>

 <style scoped>
 .bg-danger{
  background-color:#72e8ff!important
 }
.bg-primary{
  background-color:#9dcdff!important
}
.bg-yellow {
    background-color: #f3ff77!important;
}
/deep/ .el-select-dropdown__item.selected{
  color:#000
}
.text-cancel{
  color: #f52706;
}
/deep/ .el-input__inner{
  background:transparent;
  border:1px solid #cfcfcf;
  border-radius:2px;
}
/deep/ .el-dialog__body{
  padding:10px 20px;
}
/deep/ .el-form-item {
  margin-bottom:10px;
}

/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }
 /deep/.typeIco .el-input__icon{
  line-height: 30px;
 }
.text-orange{
  color: #e79e44;
}
>>> .el-table__body tr.current-row > td {
    background-color: #d3d3d3!important;
  }
</style>



// WEBPACK FOOTER //
// src/views/moneyout/list.vue